<svelte:options customElement={{ tag: "bt-collapsible-trigger" }} />

<script lang="ts">
  import Icon from '$shared/icons/Icon.svelte';

  export let targetID: string = "";
  export let isExpanded: boolean = false;
  export let expandText: string = "";
  export let collapseText: string = ""
  export let design: "button" | "chevron-button" = "button";
  export let toggleMode: "hide" | "class" = "hide";
  export let expandedClass = ""
  export let collapsedClass = ""

  const handleClick = (event) => {
    const target = document.querySelector(`#${targetID}`)
    if (target) {
      isExpanded = !isExpanded;
      if (toggleMode === 'hide') {
        target.toggleAttribute('hidden');
      }
      else if (toggleMode === 'class') {
        if (isExpanded) { 
          target.classList.add(expandedClass)
          target.classList.remove(collapsedClass)
        } else {
          target.classList.add(collapsedClass)
          target.classList.remove(expandedClass)
        }
      }

      if (expandText && collapseText && design !== "chevron-button") {
        if (isExpanded) {
          event.srcElement.innerText = collapseText;
        } else {
          event.srcElement.innerText = expandText;
        }
      }
    }
  }
</script>

<button on:click={handleClick} aria-controls={targetID} aria-expanded={isExpanded} class={`collapsible-button ${expandText && collapseText ? 'collapsible-button--nonslotted' : ''} collapsible-button--design-${design}`}>
  {#if design === 'chevron-button'}
    {#if isExpanded}
      <span>{collapseText}</span>
      <Icon icon="ChevronUp" size="small"/>
    {:else}
      <span>{expandText}</span>
      <Icon icon="ChevronDown" size="small"/>
    {/if}
  {:else if expandText && collapseText}
    {expandText}
  {:else}
    <slot />
  {/if}
</button>

<style>
  .collapsible-button {
    all: inherit;
    cursor: pointer;
  }
  .collapsible-button--nonslotted {
    border: 1px solid theme('colors.neutral.300');
    border-radius: theme('borderRadius.lg');
    font-weight: 500;
    padding: 10px theme('spacing.6');
    &:hover {
      background: theme('colors.neutral.200');
    }
  }
  .collapsible-button--design-chevron-button {
    background: white;
    border: 1px solid theme('colors.neutral.300');
    border-radius: theme('borderRadius.lg');
    font-weight: 500;
    padding: 0 1rem;
    width: max-content;
    height: theme('spacing.10');
    font-size: theme('fontSize.sm');
    z-index: 2;
    display: flex;
    align-items: center;
    gap: .5rem;
    box-shadow: 0 6px 10px -4px rgba(82, 82, 82, 0.2), 0 3px 20px 0 rgba(82, 82, 82, 0.1), 0 4px 8px 2px rgba(82, 82, 82, 0.02);
    &:hover {
      background: theme('colors.neutral.100');
    }
  }
</style>
